angular.module('env.data.models.userModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes, FieldValidationTemplates) {
        var emailPattern = /([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})/; // todo copy from server-side
        // Regex of short version of IETF standard
        var culturePattern = /^([a-z]{2,3})(?:[\-_ ]([a-z]{4}))?(?:[\-_ ]((?:[a-z]{1,3})|(?:[0-9]{3})))?(?:[\-_ ]([a-z0-9]{5,8}))?$/i;

        restProvider.defineModel("UserModel",
            {
                extend: ["BaseModel"],
                url: "users",
                fields: {
                    name: {
                        type: RepresentationModelFieldTypes.STRING,
                        validators: FieldValidationTemplates.notEmpty()
                    },
                    lastName: {
                        type: RepresentationModelFieldTypes.STRING,
                        validate: FieldValidationTemplates.notEmpty()
                    },
                    firstName: {
                        type: RepresentationModelFieldTypes.STRING,
                        validate: FieldValidationTemplates.notEmpty()
                    },
                    title: {
                        type: RepresentationModelFieldTypes.STRING,
                        validate: FieldValidationTemplates.notEmpty()
                    },
                    email: {
                        type: RepresentationModelFieldTypes.STRING,
                        validate: [
                            function (val) {
                                return val && val !== '' && emailPattern.test(val);
                            },
                            "E-mail is not valid"
                        ]
                    },
                    disabled: {
                        type: RepresentationModelFieldTypes.BOOLEAN
                    },
                    culture: {
                        type: RepresentationModelFieldTypes.STRING,
                        validate: [
                            function (val) {
                                return val && val !== '' && culturePattern.test(val);
                            },
                            "Culture code is not valid"
                        ]
                    },

                    role: {
                        subResource: true,
                        get: function (rest, model) {
                            return rest.map(model.getDefinition()).map(model).map("role").get();
                        }
                    },
                    permissions: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.ARRAY,
                        get: function (rest, model) {
                            return rest.map(model.getDefinition()).map(model).map("permissions").get();
                        }
                    },
                    centres: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.ARRAY,
                        get: function (rest, model) {
                            return rest.map(model.getDefinition()).map(model).map("centres").willReturn("CentreModel").get();
                        }
                    },
                    customers: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.ARRAY,
                        get: function (rest, model) {
                            return rest.map(model.getDefinition()).map(model).map("customers").willReturn("CustomerModel").get();
                        }
                    },
                    groups: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.ARRAY,
                        get: function (rest, model) {
                            return rest.map(model.getDefinition()).map(model).map("groups").get();
                        }
                    }
                },

                methods: {
                    isCustomer: function (rest, model) {
                        return !!model.$model.role.isCustomer;
                    },
                    isCentre: function (rest, model) {
                        return !!model.$model.role.isCentre;
                    },
                    getCulture: function (rest, model) {
                        return model.$model.culture;
                    }
                }
            }
        );
    })

;